// Users arrive from different endpoints with different name fields populated
// (users list: fullName; eligible-AEs: first/last; some carry only an email,
// under either `email` or `emailAddress`).
export const getUserDisplayName = user =>
  user?.fullName ||
  [user?.firstName, user?.lastName].filter(Boolean).join(' ') ||
  user?.email ||
  user?.emailAddress ||
  null;
